import React, { useEffect } from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, LabelList } from 'recharts';
import ResponsiveLegend from "utils/ResponsiveLegendChart";
import { formateMonthName } from "utils/formats";

export default function DespesaOcupacaoChart({ despesaOcupacaoData }) {

    const [chartAndTableData, setChartAndTableData] = React.useState([]);
    const { getLegendPosition, windowWidth } = ResponsiveLegend();

    useEffect(() => {
        if (despesaOcupacaoData && despesaOcupacaoData.length > 0) {
            let mappedData = despesaOcupacaoData.map((data) => ({
                name: formateMonthName(data.mesAno),
                aluguelPdv: data.aluguelPdv,
                condominioPdv: data.condominioPdv,
                fundoPromocaoPdv: data.fundoPromocaoPdv,
                aluguelPercentual: data.percentualAluguel,
                condominioPercentual: data.percentualCondominio,
                fundoPromocaoPercentual: data.percentualFundoPromocao,
                aluguel: data.aluguel,
                condominio: data.condominio,
                fundoPromocao: data.fundo,
                outros: data.outros,
                outrosPdv: data.outrosPdv,
                outrosPercentual: data.outrosPercentual
            }));
            setChartAndTableData(mappedData);
        }
    }, [despesaOcupacaoData]);

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            const percentualFundoPromocao = `${new Intl.NumberFormat('pt').format(data.fundoPromocaoPercentual)}%`
            const percentualCondominio = `${new Intl.NumberFormat('pt').format(data.condominioPercentual)}%`
            const percentualAluguel = `${new Intl.NumberFormat('pt').format(data.aluguelPercentual)}%`
            const percentualOutros = `${new Intl.NumberFormat('pt').format(data.outrosPercentual)}%`
            const pdvAlugel = `R$ ${data.aluguelPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvCondominio = `R$ ${data.condominioPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvFundoPromocao = `R$ ${data.fundoPromocaoPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvOutros = `R$ ${data.outrosPdv.toLocaleString('pt-BR').split(',')[0]}`;
            return (
                <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
                    <p>{data.name}</p>
                    <p>FUNDO PROMOÇÃO %: {percentualFundoPromocao}</p>
                    <p>CONDOMÍNIO %: {percentualCondominio}</p>
                    <p>ALUGUEL %: {percentualAluguel}</p>
                    <p>OUTROS %: {percentualOutros}</p>
                    <p>ALUGUEL/PDV: {pdvAlugel}</p>
                    <p>CONDOMÍNIO/PDV: {pdvCondominio}</p>
                    <p>FUNDO PROMOÇÃO/PDV: {pdvFundoPromocao}</p>
                    <p>OUTROS/PDV: {pdvOutros}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div>
            <ResponsiveContainer width='99%' height={400}>
                <ComposedChart
                    width={1200}
                    height={400}
                    data={chartAndTableData}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 5,
                        bottom: 10
                    }}
                >
                    <XAxis dataKey="name" stroke="#000" axisLine={false} tickLine={false} style={{ fontWeight: 'bold' }} />
                    <YAxis hide />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                        align={windowWidth > 600 ? 'left' : 'center'}
                        layout={windowWidth > 600 ? 'vertical' : 'horizontal'}
                        iconSize={10}
                        wrapperStyle={(windowWidth > 600) ? { ...getLegendPosition(),  minWidth: '140px', width: '140px',maxWidth: '140px'} : { ...getLegendPosition() }}
                        formatter={(value, entry) => <span style={{ color: '#000', fontSize: '9px' }}>{value}</span>}
                        payload={[
                            { value: 'FUNDO PROMOÇÃO %', type: "rect", color: "#d7ebe0", },
                            { value: 'CONDOMÍNIO %', type: "rect", color: "#f4edda" },
                            { value: 'ALUGUEL %', type: "rect", color: "#e0e4ed" },
                            { value: 'OUTROS %', type: "rect", color: "#edd9da" },
                            { value: 'ALUGUEL / PDV', type: "line", color: "#ba7909" },
                            { value: 'CONDOMÍNIO / PDV', type: "line", color: "#606f90" },
                            { value: 'FUNDO PROMOÇÃO / PDV', type: "line", color: "#3f8b65" },
                            { value: 'OUTROS / PDV', type: "line", color: "#7e1b1e" },
                        ]}
                    />
                    <Bar
                        dataKey="aluguelPercentual"
                        name="ALUGEL %"
                        fill="#e0e4ed"
                        stackId="123"
                    />
                    <Bar
                        dataKey="condominioPercentual"
                        name="CONDOMÍNIO %"
                        fill="#f4edda"
                        stackId="123"
                    />
                    <Bar
                        dataKey="fundoPromocaoPercentual"
                        name="FUNDO PROMOÇÃO %"
                        fill="#d7ebe0"
                        stackId="123"
                    />
                    <Bar
                        dataKey="outrosPercentual"
                        name="OUTROS %"
                        fill="#edd9da"
                        stackId="123"
                    />
                    <Line type="monotone" dataKey="aluguelPercentual" name="ALUGUEL/PDV" stroke="#ba7909" dot={false}>
                        <LabelList
                            dataKey="aluguelPdv"
                            fill="#ba7909"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="condominioPercentual" name="CONDOMÍNIO/PDV" stroke="#5f708c" dot={false}>
                        <LabelList
                            dataKey="condominioPdv"
                            fill="#5f708c"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="fundoPromocaoPercentual" name="FUNDO PROMOÇÃO/PDV" stroke="#478762" dot={false}>
                        <LabelList
                            dataKey="fundoPromocaoPdv"
                            fill="#478762"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="outrosPercentual" name="OUTROS/PDV" stroke="#7e1b1e" dot={false}>
                        <LabelList
                            dataKey="outrosPdv"
                            fill="#7e1b1e"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                </ComposedChart>
            </ResponsiveContainer>
            <div style={{ marginRight: '40px' }}>
                <table
                    style={{
                        width: '100%',
                        borderTop: '1px solid #000',
                        borderBottom: '1px solid #000',
                        overflow: 'auto',
                        tableLayout: 'fixed'
                    }}>
                    <tbody>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>ALUGUEL</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.aluguel.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.aluguelPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>CONDOMÍNIO</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.condominio.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.condominioPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>FUNDO</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.fundoPromocao.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.fundoPromocaoPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>OUTROS</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.outros.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.outrosPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
